import PropTypes from "prop-types";
import Image from "components/atoms/Image";

import Letters from "components/atoms/Letters";
import Hint from "components/atoms/Hint";
import {
  getTransliteratedId,
  getWordBySyllable,
  testLowerCase,
  splitBySyllables,
  isNotConsonant,
} from "utils/Language/LanguageAnalysis";
import "./styles.scss";

const Syllables = ({
  word,
  type,
  lettersVsPicsProbability = 0,
  isInASentence = false,
  demoItemsRevealed = 1,
}) => {
  let syllablesArray = word ? splitBySyllables(word) : null;
  return word ? (
    <ul
      className={["syllables", type, isInASentence && "in-a-sentence"]
        .join(" ")
        .trim()}
    >
      {syllablesArray?.map((syllable, index) => {
        const randomNumber = Math.random() * 100;
        const isLetters = lettersVsPicsProbability > randomNumber;
        const modifiedSyllable = isLetters ? syllable.toUpperCase() : syllable;
        const picturePath = getTransliteratedId(syllable);
        return (
          <li
            key={syllable + index}
            className={`${
              testLowerCase(syllable) && !isNotConsonant(syllable) && "syllable"
            }
              ${type !== "read-sentence" && "main-word"}
              ${type}
            `}
          >
            {testLowerCase(modifiedSyllable) && isNotConsonant(syllable) ? (
              <Image
                filename={picturePath}
                className={
                  type === "demo" && demoItemsRevealed <= index
                    ? "invisible"
                    : ""
                }
              />
            ) : (
              <Letters
                text={syllable?.toUpperCase()}
                size="lg"
                isSentence={type === "read-sentence"}
                className={
                  type === "demo" && demoItemsRevealed <= index
                    ? "invisible"
                    : ""
                }
              />
            )}
            {type === "read" || type === "demo" ? (
              <Letters
                text={syllable?.toUpperCase()?.replace("1", "")}
                size={type}
                className={
                  type === "demo" &&
                  index + syllablesArray.length >= demoItemsRevealed
                    ? "invisible"
                    : ""
                }
              />
            ) : null}
            {type !== "read-sentence" && type !== "demo" && (
              <Hint text={getWordBySyllable(syllable)} shaded={true} />
            )}
          </li>
        );
      })}
    </ul>
  ) : null;
};

Syllables.propTypes = {
  word: PropTypes.string,
  type: PropTypes.string,
};

export default Syllables;
